import React from "react";
import Routers from "routes/Routers";
import { CommonProvider } from "core/context/useContext";
import { SWR } from "core/hooks/swr";

function App() {
  return (
    <>
      <CommonProvider>
        <SWR>
          <Routers />
        </SWR>
      </CommonProvider>
    </>
  );
}

export default App;
